import { Theme } from '@mui/material';
import { MatchResultPlayerStatus } from '@okletsplay/core';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    '&.MuiTypography-root': {
      lineHeight: 1,
      fontSize: theme.spacing(3.25),
      fontWeight: 'bold',
      flexFlow: 'inherit',
      letterSpacing: '0.05em',
      fontFamily: '"Bebas Neue"',
    },
  },

  [MatchResultPlayerStatus.Win]: {
    '&.MuiTypography-root': {
      color: theme.palette.success.light,
    },
  },

  [MatchResultPlayerStatus.Lose]: {
    '&.MuiTypography-root': {
      color: theme.palette.error.light,
    },
  },

  [MatchResultPlayerStatus.Tied]: {
    '&.MuiTypography-root': {
      color: theme.palette.text.primary,
    },
  },

  [MatchResultPlayerStatus.Forfeit]: {
    '&.MuiTypography-root': {
      color: theme.palette.text.primary,
    },
  },
}));
